module.exports = __webpack_public_path__ + "static/img/02.d609a027.png";